module.exports = __webpack_public_path__ + "components/flag/static/square/aq-13b6f0d602cf765bbdc66a9a04fb4fb5.svg";